<template>
  <div class="legend">
    <div class="wrapper">
      <table ref="subTable" class="bordered">
        <tr v-for="(definition, i) in statisticDefinitions" v-bind:key="'stat_' + i">
          <td>{{definition.label}}</td>
          <td>{{definition.ci !== null ? '(95% Confidence Interval)' : ''}}</td>
          <td>{{definition.se !== null ? 'Standard Error' : ''}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  /* eslint no-unused-vars: 'off' */

  export default {
    /*model: {
      isEnabled: 'true'
    },*/
    props: ['statisticDefinitions'],
    created: function () {
    },
    data: function () {
      var vm = this;
      return {
      }
    },
    methods: {
    }
  }
</script>

<style scoped>
  .wrapper {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .bordered {
    border: 2px solid;
  }
  td {
    font-size:12px;
    line-height: 16px;
    padding: 2px 8px 2px 8px;
  }

</style>
